import React,{useEffect,useState} from 'react';
import {Alert,Button} from 'antd';
export default function GeoRetry({lookup,label='Reintentar dirección'}) {
  const state=lookup.wait || lookup.error;
  const deadline=state?.retryAt || 0;
  const [now,setNow]=useState(Date.now());
  useEffect(()=>{
    setNow(Date.now());
    if(deadline<=Date.now())return;
    const timer=setInterval(()=>{setNow(Date.now());if(Date.now()>=deadline)clearInterval(timer);},1000);
    return ()=>clearInterval(timer);
  },[deadline]);
  const seconds=Math.max(0,Math.ceil((deadline-now)/1000));
  if(!state || state.code==='public_control_verification_required')return null;
  return <Alert type={lookup.wait?'info':'warning'} showIcon message={state.message} style={{marginTop:8}}
    description={seconds>0?(lookup.wait?`Volveremos a intentar en ${seconds} s.`:`Podrás reintentar en ${seconds} s.`):undefined}
    action={!lookup.wait && <Button size="small" disabled={seconds>0 || lookup.busy} loading={lookup.busy} onClick={lookup.retry}>{label}</Button>} />;
}
